import { render, staticRenderFns } from "./CmgSessionExpiredBar.vue?vue&type=template&id=517de563&scoped=true&lang=pug"
import script from "./cmg-session-expired-bar.ts?vue&type=script&lang=ts&external"
export * from "./cmg-session-expired-bar.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgSessionExpiredBar.vue?vue&type=style&index=0&id=517de563&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517de563",
  null
  
)

export default component.exports